// extracted by mini-css-extract-plugin
module.exports = {"root":"FullAvailability_root__3IDER","secondaryButton":"FullAvailability_secondaryButton__sxcFQ"};